import React, {useEffect, useState} from 'react';
import {useSearchParams} from 'react-router-dom';
import {Grid, Box} from '@mui/material';
import apiCall, {setUserToken} from '@/utils/api';
import Loader from '@/shared/Loader';
import RateOfReachingExpected from 'src/containers/FdcMilanoBeneficiaries/Charts/RateOfReachingExpected';
import CompositionOfAccompanied from 'src/containers/FdcMilanoBeneficiaries/Charts/CompositionOfAccompanied';
import SummaryIndex from 'src/containers/FdcMilanoBeneficiaries/Charts/SummaryIndex';
import {ISubmissionProps} from '@/containers/FdcMilanoBeneficiaries/resources/submission';

import './styles.scss';

const FdcMilanoBeneficiaries = () => {
    const [searchParams] = useSearchParams();
    const container = searchParams.get('container_id');
    const monitoringSurvey  = searchParams.get('monitoring_survey');
    const monitoringProfileSurvey = searchParams.get('monitoring_profile_survey');

    setUserToken(searchParams.get('token') || '')

    const [loading, setLoading] = useState<boolean>(true);
    const [monitoringSubmissions, setMonitoringSubmissions] = useState<ISubmissionProps[]>([]);
    const [monitoringProfileSubmissions, setMonitoringProfileSubmissions] = useState<ISubmissionProps[]>([]);

    const getSurvey = async () => {
        try {
            const responses = await apiCall({
                url: `containers/${container}/submissions`,
                params: {
                    survey_id: monitoringSurvey,
                    completed: 1,
                    additional_data: false,
                },
            });
            const responsesMonitoringProfile = await apiCall({
                url: `containers/${container}/submissions`,
                params: {
                    survey_id: monitoringProfileSurvey,
                    completed: 1,
                    additional_data: false,
                },
            });

            setMonitoringSubmissions(responses.data.submissions);
            setMonitoringProfileSubmissions(responsesMonitoringProfile.data.submissions);
        } catch (e) {
            console.error(e);
        }
    }

    useEffect(() => {
        getSurvey().then(() => setLoading(false));
    }, []);

    return (
        <Box p={2}>
            {
                !loading && (
                    <>
                        <Grid container rowSpacing={1} columnSpacing={{xs: 1, sm: 2, md: 3}}>
                            <Grid item xs={6}>
                                <RateOfReachingExpected
                                    submissions={monitoringSubmissions}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <CompositionOfAccompanied
                                    submissions={monitoringSubmissions}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <SummaryIndex
                                    submissions={monitoringProfileSubmissions}
                                />
                            </Grid>
                        </Grid>
                    </>
                )
            }
            {
                loading && (
                    <Box className='loader-container'>
                        <Loader size={60}/>
                    </Box>
                )
            }
        </Box>
    )
}

export default FdcMilanoBeneficiaries;